
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Getter, Mutation } from 'vuex-class';
import { Build } from '@/types/build';
import moment from 'moment';

@Component
export default class BuildTimeLine extends Vue {
  @Getter('builds/showSummaryPanel') showSummaryPanel!: number | null;
  @Mutation('builds/updateShowSummaryPanel') updateShowSummaryPanel!: Function;
  @Prop() build!: Build;
  @Prop() buildInProgress!: boolean;

  get createdAt(): string {
    moment.locale('en-gb');
    return moment(this.build.created_at as string).fromNow();
  }

  get progressValue(): string {
    return (
      (this.build.current_count / this.build.total_count) *
      100
    ).toLocaleString('en-GB', { maximumFractionDigits: 0 });
  }

  get showPanel(): number | null {
    return this.showSummaryPanel;
  }
  set showPanel(value) {
    this.updateShowSummaryPanel(value);
  }
}
